import clsx from "clsx";
import shape from "../../assets/img/shapes/line-shape-01.webp";


const LineShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-line-shape-01", props.className)}>
            <img src={shape} alt="rmdr-line-shape-01" loading="lazy" width={195} height={254} />
        </div>
    )

}

export default LineShape01;
